export default "<div class=\"overlay overlay--light {{loading ? 'is-open' : ''}}\">\n  <loader></loader>\n</div>\n";